module.exports = __webpack_public_path__ + "static/header-background_480.f9aad8b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-background_480.png
// module id = 1249
// module chunks = 35783957827783